import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['searchTerm'];

  static values = { url: String };

  submit(e) {
    e.preventDefault();
    const searchTerm = this.searchTermTarget.value;
    if (searchTerm && searchTerm !== '') {
      window.Turbo.visit(`${this.urlValue}?s=${encodeURI(searchTerm)}`);
    }
  }
}
